import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import GuestRSVP from "@/pages/GuestRSVP";
import IntroOverlay from "@/components/IntroOverlay";

const HashScroller = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
    }
  }, [location]);
  return null;
};

const IntroGate = () => {
  const location = useLocation();
  if (location.pathname !== "/") return null;
  return <IntroOverlay />;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <HashScroller />
        <IntroGate />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rsvp" element={<GuestRSVP />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
